import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import {
    Card,
    CardContent,
    Typography,
} from '@material-ui/core';
import SecureFetchContext from 'context/SecureFetchContext';
import getApiRoute from 'routes/apiRoutes';
import { Bar } from 'react-chartjs-2';

const PackageProfitByMonthStatistics = ({ params, ...rest }) => {
    const { t } = useTranslation();
    const secureFetch = useContext(SecureFetchContext);
    const [data, setData] = useState([]);
    const [labels, setLabels] = useState([]);

    useEffect(() => {
        secureFetch(getApiRoute('admin_statistics', ['monthpackageprofit']) + '?' + params).then(json => {
            let tmpData = {
                domestic_profit: [],
                foreign_profit: [],
                parcelshop_local_profit: [],
                parcelshop_international_profit: [],
            };
            let tmpLabels = [];
            for (const obj of json) { //sort by year, month
                tmpLabels.push(obj.month);
                tmpData.domestic_profit.push( obj.domestic_profit );
                tmpData.foreign_profit.push( obj.foreign_profit );
                tmpData.parcelshop_local_profit.push(obj.parcelshop_local_profit);
                tmpData.parcelshop_international_profit.push(obj.parcelshop_international_profit);
            }

            setData(tmpData);
            setLabels(tmpLabels);
        });
    }, [secureFetch, params]);
  
    const chartData = {
        labels: labels.map((val) => {
            let date = new Date(val);
            return (date.getMonth() + 1) + '/' + date.getFullYear();
        }),
        datasets: data.length === 0 ? null : [
            {
                label: t('label.domestic_packages'),
                data: data.domestic_profit,
                backgroundColor: 'rgb(32, 87, 144)',
            },
            {
                label: t('label.foreign_packages'),
                data: data.foreign_profit,
                backgroundColor: 'rgb(88, 168, 60)',
            },
            {
                label: t('label.parcelshop_local'),
                data: data.parcelshop_local_profit,
                backgroundColor: 'rgb(230, 96, 34)',
            },
            {
                label: t('label.parcelshop_international'),
                data: data.parcelshop_international_profit,
                backgroundColor: 'rgb(240, 252, 47)',
            },
        ],
    }

    const options = {
        scales: {
            yAxes: [
                {
                    stacked: true,
                    ticks: {
                        beginAtZero: true,
                    },
                },
            ],
            xAxes: [
                {
                    stacked: true,
                },
            ],
        },
        tooltips: {
            // enabled: false,
            callbacks: {
                label: (tooltipItem, data) => {
                    const name = data.datasets[tooltipItem.datasetIndex].label;
                    const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                    let total = 0;
                    for (const v of data.datasets) {
                        total += parseFloat(v.data[tooltipItem.index]);
                    }
                    return `${name}: ${parseFloat(value).toFixed(2)} € / ${parseFloat(total).toFixed(2)} €`;
                }
            }
        }
    }

    return (
        <Card
            {...rest}
        >
            <CardContent>
                <Typography gutterBottom variant="h4" component="h2" align="center">
                    {t('title.profit_month')}
                </Typography>
                <Bar height={80} data={chartData} options={options} />
            </CardContent>
        </Card>
    );
}

export default PackageProfitByMonthStatistics;